import { Box, Typography, Button } from "@mui/material";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";

const DonateCallToAction = () => {
  return (
    <Box
      sx={{
        // background: "linear-gradient(135deg, #3f51b5, #5c6bc0)",
        // background: "linear-gradient(135deg, #3f51b5, #5c6bc0)",
        background:"#fff",
        color: "white",
        p: { xs: 3, md: 5 },
        borderRadius: 3,
        textAlign: "center",
        mt: 5,
        boxShadow: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography
        variant="h5"
        fontWeight={700}
        sx={{ 
          color: "black",mb: 2, textShadow: "0px 1px 2px rgba(0,0,0,0.2)" }}
      >
        Support This Project
      </Typography>

      <Typography
        variant="body1"
        sx={{
          color: "black",
          maxWidth: 600,
          mb: 3,
          lineHeight: 1.6,
          opacity: 0.9,
        }}
      >
        Your donation helps expand access to clean water, strengthen climate
        resilience, and empower local communities to build a sustainable future.
        Every contribution — big or small — makes a difference.
      </Typography>

      <Button
        variant="contained"
        color="secondary"
        size="large"
        startIcon={<VolunteerActivismIcon />}
        sx={{
          px: 4,
          py: 1.2,
          borderRadius: 8,
          fontWeight: 600,
          textTransform: "none",
          boxShadow: "0px 4px 12px rgba(0,0,0,0.3)",
          transition: "all 0.3s ease",
          "&:hover": {
            transform: "scale(1.05)",
            boxShadow: "0px 6px 16px rgba(0,0,0,0.35)",
          },
        }}
        onClick={() => alert("Redirect to donation page")}
      >
        Donate Now
      </Button>
    </Box>
  );
};

export default DonateCallToAction;
